export default {
    'not completed': 'Not completed',
    'in progress': 'In progress',
    done: 'Done'
};
